export function removeHTMLTags(str) {
    // Create a new DOM element
    let tempDiv = document.createElement("div");
    // Assign the input string as the innerHTML of the new element
    tempDiv.innerHTML = str;
    // Use textContent to get the plain text
    return tempDiv.textContent || tempDiv.innerText || "";
  }
  